// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/scss/bundle.scss
// module id = ./src/scss/bundle.scss
// module chunks = 0